<template>
  <a-modal
    v-model="imgVisible"
    :destroy-on-close="true"
    :footer="null"
    :width="width"
    :closable="closable"
    :maskClosable="false"
    centered
    class="bgModal"
    @cancel="hide"
    :bodyStyle="bodyStyle"
  >
    <slot></slot>
    <slot name="closeIcon"> </slot>
  </a-modal>
</template>

<script>
export default {
  name: 'BgModal',
  data () {
    return {
      imgVisible: false
    }
  },
  props: {
    bodyStyle: {
      type: Object,
      default: () => { }
    },
    closable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '480px'
    }
  },
  components: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {
    showModal () {
      this.imgVisible = true
    },
    hide () {
      this.imgVisible = false
    }
  }
}
</script>

<style lang="less">
.bgModal {
  .update-title {
    color: #ff7401;
    font-size: 24px;
    text-align: center;
    padding: 38px 0 33px;
    line-height: 1;
  }
  .close-modal-icon {
    position: absolute;
    right: 44px;
    top: 20px;
    cursor: pointer;
  }
  .update-content {
    width: 650px;
    margin: 0 0 0 64px;
    height: 250px;
    overflow: auto;
    .desc {
      font-size: 16px;
      color: #333333;
      display: flex;
      line-height: 24px;
      margin-bottom: 13px;
      span {
        display: block;
        width: 644px;
      }
    }
  }
  .wellcomeModal {
    .content {
      position: absolute;
      top: 144px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .desc {
        color: #333333;
        font-size: 16px;
        line-height: 1;
        text-align: left;
      }
      .title {
        color: #ff7401;
        font-size: 18px;
        line-height: 1;
      }
    }
    .btn-list {
      text-align: center;
      position: absolute;
      bottom: 48px;
      width: 100%;
      .cancel-btn {
        width: 120px;
        height: 40px;
        border-radius: 8px;
        box-shadow: 0px 3px 4px 0px #ff7401;
        color: #999999;
        font-size: 18px;
        border: none;
        &:hover {
          color: #ff7401;
        }
      }
      .confirm-btn {
        width: 120px;
        height: 40px;
        border-radius: 8px;
        margin-left: 60px;
        color: #ff7401;
        font-size: 18px;
        box-shadow: 0px 3px 4px 0px #ff7401;
        border: none;
      }
    }
  }
  .changeService_wrap {
    .update-content {
      margin-top: 10px;
      .color_text {
        display: inline;
        color: #ff7401;
      }
      .checkboxStyle span {
        display: inline-block;
        width: 16px;
      }
    }
    .btn_wrap {
      text-align: center;
      position: relative;
      bottom: -80px;

      .yes-btn {
        width: 330px;
        height: 50px;
        border-radius: 8px;
        color: #ff7401;
        font-size: 18px;
        box-shadow: 0px 3px 4px 0px #ff7401;
        border: none;
      }
    }
  }
}

.AuthenticationModal-content {
  font-size: 18px;
  color: #333333;
  text-align: center;
  padding-top: 71px;
  p {
    line-height: 28px;
    font-size: 18px;
  }
  .title {
    position: absolute;
    top: -150px;
    left: 0;
    color: @primary-color;
    text-align: center;
    font-size: 24px;
    width: 480px;
    height: 200px;
    img {
      position: absolute;
      width: 100%;
      height: auto;

      left: 0;
    }
  }
}
.agree-btn {
  text-align: center;
}
</style>
